// src/components/Popup.js
import React from "react";
import "./Popup.css"; // 팝업 전용 스타일

function Popup({ onClose, onNeverShow }) {
  return (
    <div className="popup-container fixed inset-0 bg-black/60 flex items-center justify-center z-[10000]">
      <div className="popup-content bg-white p-5 rounded-lg shadow-lg max-w-sm w-full relative text-center">

        {/* 오른쪽 상단 X 버튼 */}
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-gray-500 hover:text-black text-xl"
        >
          ✖
        </button>

        {/* 제목 */}
        <h2 className="text-lg font-bold mb-3">🖤 반딧불 흑임자 팥빙수 출시 🤍</h2>

        {/* 이미지 */}
        <img
          src={`${process.env.PUBLIC_URL}/eventimg/bingsu.gif`}
          alt="흑임자 팥빙수 출시"
          className="popup-image mx-auto mb-3 rounded max-w-[80%] transition-all duration-300"
        />

        {/* 설명 문구 */}
        <p className="mb-3 leading-relaxed text-sm">
          까맣게 고소하고, 하얗게 시원하다.<br />
          진한 <strong>흑임자</strong>와 <strong>눈꽃 얼음</strong>이 만난<br />
          <strong>반딧불 흑임자 팥빙수</strong> 출시 🖤
        </p>

        {/* 버튼 영역 */}
        <div className="flex flex-col gap-3 items-center mt-4">

          {/* 메뉴 보기 버튼 */}
          <button
            onClick={() => (window.location.href = "/cafe/menu")}
            className="px-4 py-2 w-full bg-neutral-800 text-white rounded-md hover:bg-black transition text-sm"
          >
            카페 메뉴 보기
          </button>

          {/* 아래쪽 두 버튼 (닫기 / 다시 보지 않기) */}
          <div className="flex justify-center gap-4 mt-1">

            {/* 팝업만 닫기 */}
            <button
              onClick={onClose}
              className="text-sm text-gray-600 hover:text-gray-800 underline"
            >
              닫기
            </button>

            {/* 다시 보지 않기 */}
            <button
              onClick={onNeverShow}
              className="text-sm text-gray-500 hover:text-gray-700 underline"
            >
              다시 보지 않기
            </button>

          </div>
        </div>

      </div>
    </div>
  );
}

export default Popup;
